
import React, {useMemo, useRef} from "react";
import {v4 as uuidv4} from "uuid";
import Form, {FormGeneratorHandles} from "@/components/Form";
import addNewFileFormItems from "@/components/Theme/ThemeEditor/forms/addNewFileFormItems";
import Button from "../../UiElements/Button";
import {Elements} from '@/types/theme'

interface AddThemeElementProps {
    onClose: () => void;
    addFile: (data:Elements) => void;
    existFiles: Elements[];
}

const AddThemeElement: React.FC<AddThemeElementProps> = ({onClose, addFile, existFiles}) => {

    const formRef = useRef<FormGeneratorHandles>(null);
    const defaultValues = useMemo(() => ({existFiles: existFiles}), []);
    const fileNames = useMemo(() => existFiles.map((file) => file.name), [existFiles]);
    const items = useMemo(() => addNewFileFormItems(fileNames), [fileNames]);

    const handleFormSubmit = async () => {

        if (formRef.current) {
            const data = formRef.current.getData();

            try {
                const formValidate = await formRef.current.validate()
                if (!formValidate?.length) {

                    const fileData:Elements = {

                        name : data.name,
                        jsx: data.jsx || "",
                        css: data.css || "",
                        mobileCss : data.mobileCss || "",
                        tabletCss : data.tabletCss || "",

                        hints : [],
                        note: data.note || "",
                        status: "new",

                        id : uuidv4(),
                        pinned: true
                    }


                    addFile(fileData);
                    onClose();
                }

            } catch (errors) {
                console.error("Validation errors:", errors);
            }
        }
    }

    return(
        <div className={"flex flex-col gap-xxxl"}>
            <div className={"w-[750px] grid grid-cols-12 gap-md"}>
                <Form
                    ref={formRef}
                    items={items}
                    defaultValues={defaultValues}
                />
            </div>
            <div className={"flex flex-row justify-between gap-md"}>


                <Button
                    onClick={onClose}
                    type={"alt"}
                    className={"flex-1 inset-1"}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleFormSubmit}
                    className={"flex-1  inset-1"}
                >
                    Add File
                </Button>


            </div>
        </div>
    )
}


export default AddThemeElement;